{
  "COMMON": {
    "LOADING": "Loading in progress...",
    "ERROR_CODE": {
      "ALXXX": "We are sorry we cannot retrieve alternative flight options at the moment. Please choose another option or try again later. You can also contact our customer support via <a href='{{link}}' target='_blank'>this form.</a> [Error code {{errorCode}}]",
      "@ALXXX": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          },
          "errorCode": {
            "description": "Code of the error, returns by the API",
            "example": "AL001"
          }
        }
      },
      "COXXX_1": "We are sorry we cannot proceed to your booking at the moment. Please try again later. [Error code {{errorCode}}]",
      "@COXXX_1": {
        "placeholders": {
          "errorCode": {
            "description": "Code of the error, returns by the API",
            "example": "CO001"
          }
        }
      },
      "COXXX_2": "We are sorry we cannot identify your booking at the moment. Please try again later or contact our customer support via <a href='{{link}}' target='_blank'>this form.</a> [Error code {{errorCode}}]",
      "@COXXX_2": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          },
          "errorCode": {
            "description": "Code of the error, returns by the API",
            "example": "CO002"
          }
        }
      },
      "DIXXX": "We are sorry we cannot proceed to your request at the moment. Please try again later or contact our customer support via <a href='{{link}}' target='_blank'>this form.</a> [Error code {{errorCode}}]",
      "@DIXXX": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          },
          "errorCode": {
            "description": "Code of the error, returns by the API",
            "example": "DI001"
          }
        }
      },
      "EMXXX": "We are sorry the email could not be sent. Please try again later. [Error code {{errorCode}}]",
      "@EMXXX": {
        "placeholders": {
          "errorCode": {
            "description": "Code of the error, returns by the API",
            "example": "EM001"
          }
        }
      },
      "EXXXX": "We are sorry we cannot proceed to your request at the moment. Please try again later or contact our customer support via <a href='{{link}}' target='_blank'>this form.</a> [Error code {{errorCode}}]",
      "@EXXXX": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          },
          "errorCode": {
            "description": "Code of the error, returns by the API",
            "example": "EX012"
          }
        }
      },
      "EX115": "We are sorry we cannot proceed to your request at the moment. Please try again after 15 minutes or contact our customer support via <a href='{{link}}' target='_blank'>this form.</a> [Error code {{errorCode}}]",
      "@EX115": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          }
        }
      },
      "EX197": "We are sorry we faced a problem while issuing your refund. Please try again or contact our customer support via <a href='{{link}}' target='_blank'>this form.</a>",
      "@EX197": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          }
        }
      },
      "EX503": "We're experiencing a service disruption, but it'll be resolved soon. Please try again in a few minutes or contact our customer support via <a href='{{link}}' target='_blank'>this form.</a>",
      "@EX503": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          }
        }
      },
      "EX401": "Your session has expired. Please refresh the page and try again. If the problem persists, contact our customer support via <a href='{{link}}' target='_blank'>this form.</a>",
      "@EX401": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          }
        }
      },
      "OFXXX": "We are sorry we cannot proceed to your booking at the moment. Please try again later. [Error code {{errorCode}}]",
      "@OFXXX": {
        "placeholders": {
          "errorCode": {
            "description": "Code of the error, returns by the API",
            "example": "OF001"
          }
        }
      },
      "SEXXX": "We are sorry we cannot proceed to your booking at the moment. Please try again later. [Error code {{errorCode}}]",
      "@SEXXX": {
        "placeholders": {
          "errorCode": {
            "description": "Code of the error, returns by the API",
            "example": "SE001"
          }
        }
      },
      "SGXXX": "We are sorry we cannot proceed to your request at the moment. Please try again later or contact our customer support via <a href='{{link}}' target='_blank'>this form.</a> [Error code {{errorCode}}]",
      "@SGXXX": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          },
          "errorCode": {
            "description": "Code of the error, returns by the API",
            "example": "SG001"
          }
        }
      },
      "SHXXX": "We are sorry we cannot retrieve alternative flight options at the moment. Please choose another option or try again later. You can also contact our customer support via <a href='{{link}}' target='_blank'>this form.</a> [Error code {{errorCode}}]",
      "@SHXXX": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          },
          "errorCode": {
            "description": "Code of the error, returns by the API",
            "example": "SHXXX"
          }
        }
      },
      "RFXXX": "We are sorry we cannot proceed to your request at the moment. Please try again later or contact our customer support via <a href='{{link}}' target='_blank'>this form.</a> [Error code {{errorCode}}]",
      "@RFXXX": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          },
          "errorCode": {
            "description": "Code of the error, returns by the API",
            "example": "RF001"
          }
        }
      },
      "REBOOKING_TIMED_OUT": "The rebooking request timed out, but your rebooking is still being processed on our end. If you do not get any confirmation email within a few minutes, please try again later or contact our customer support via <a href='{{link}}' target='_blank'>this form.</a>",
      "@REBOOKING_TIMED_OUT": {
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          }
        }
      }
    },
    "SPREEDLY_ERROR_CODE": {
      "ACCOUNT_INACTIVE": "Your payment could not be processed. Please ensure you are using a valid test card or contact support for assistance via <a href='{{link}}' target='_blank'>this form.</a>.",
      "@ACCOUNT_INACTIVE": {
        "description": "A non-test card number was submitted against a test (unpaid) account. This can also occur when an invalid card number is submitted while testing as Spreedly assumes all unknown card numbers are real.",
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          }
        }
      },
      "BLANK": "Required field is missing. Please fill in all required payment details and try again.",
      "@BLANK": {
        "description": "The payment method field specified by the attribute property of this error was submitted without a value, which is required by Spreedly. Display an appropriate error message and prompt the user to fill in the specified fields."
      },
      "INVALID": "The payment information you entered is invalid. Please check the specified fields and try again.",
      "@INVALID": {
        "description": "The payment method field specified by the attribute property of this error was submitted with an invalid value (e.g., a month value of '13'). Display an appropriate error message and prompt the user to correct the specified fields."
      },
      "BLANK_CARD_TYPE": "The credit card number you entered is invalid. Please check the card number and try again.",
      "@BLANK_CARD_TYPE": {
        "description": "The credit card number was invalid; we were unable to determine the card type."
      },
      "EXPIRED": "The payment method you entered is expired. Please use a non-expired payment method and try again.",
      "@EXPIRED": {
        "description": "The payment method month and year indicates that it is expired. Display an appropriate error message and prompt the user to enter a non-expired payment method."
      },
      "UNKNOWN_REFERRER": "We could not verify the source of your payment request. Please try again or contact support for assistance via <a href='{{link}}' target='_blank'>this form.</a>.",
      "@UNKNOWN_REFERRER": {
        "description": "Spreedly could not determine the source (referring URL) of the form submission. A referring URL is required to identify MITM attacks.",
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          }
        }
      },
      "INVALID_REFERRER": "Your payment request could not be processed due to a security issue. Please try again or contact support for assistance via <a href='{{link}}' target='_blank'>this form.</a>.",
      "@INVALID_REFERRER": {
        "description": "The form submission did not originate from the Spreedly payment frame and has been rejected. This is a protection against MITM attempts.",
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          }
        }
      },
      "INVALID_ENVIRONMENT_KEY_PARAMETER": "An unexpected error has occurred. Please contact support for assistance via <a href='{{link}}' target='_blank'>this form.</a>.",
      "@INVALID_ENVIRONMENT_KEY_PARAMETER": {
        "description": "This error is displayed when the Spreedly environment key is missing. (initialization failed)",
        "placeholders": {
          "link": {
            "description": "Contact form link",
            "example": "https://hopper.kustomer.help/lang/en_us/"
          }
        }
      }
    },
    "BUTTON": {
      "CONTINUE": "Continue",
      "@CONTINUE": {
        "description": "Button to continue the next step of the flow."
      },
      "BACK": "Back",
      "@BACK": {
        "description": "Button to go back to the previous step of the flow."
      },
      "CLOSE": "Close",
      "@CLOSE": {
        "description": "Button to close popups."
      }
    },
    "PRODUCT_NAME": "Disruption Assistance",
    "PRODUCT_NAME_FLYADEAL": "Premium Disruption Assistance",
    "FLIGHT_INFORMATIONS": {
      "LAYOVER": "{{time}} layover - {{airportName}} ({{airportCode}})",
      "@LAYOVER": {
        "placeholders": {
          "time": {
            "description": "Duration of the layover.",
            "example": "3h10m"
          },
          "airportName": {
            "description": "Airport name of the layover.",
            "example": "Calgary International Airport"
          },
          "airportCode": {
            "description": "Airport code of the layover.",
            "example": "YYC"
          }
        }
      },
      "BOOKING_REFERENCE": "Booking Reference: {{pnrReference}}",
      "@BOOKING_REFERENCE": {
        "placeholders": {
          "pnrReference": {
            "description": "Passenger Name Record (PNR) reference number.",
            "example": "ABC123"
          }
        }
      },
      "STATUS": {
        "CANCELLED": "Cancelled",
        "DELAYED": "Delayed",
        "FLOWN": "Flown",
        "BOARDED": "Boarded",
        "CONFIRMED": "Confirmed"
      },
      "CABIN": {
        "ECONOMY": "Economy",
        "PREMIUM_ECONOMY": "Premium economy",
        "BUSINESS": "Businesss",
        "FIRST": "First"
      },
      "NO_STOP": "Direct",
      "STOP": {
        "ZERO": "{{count}} stops in {{destinations}}",
        "@ZERO": {
          "description": "This a pluralized string of form [X stop(s) in Y]. 'Y' are all the stop destinations",
          "placeholders": {
            "count": {
              "description": "PH({{count}}|1|There is/are {?} stop(s) during the trip.)"
            },
            "destination": {
              "description": "Destination(s) of the stop(s) (Airport code)",
              "example": "CDG, YYC"
            }
          }
        },
        "ONE": "{{count}} stop in {{destinations}}",
        "@ONE": {
          "description": "This a pluralized string of form [X stop(s) in Y]. 'Y' are all the stop destinations",
          "placeholders": {
            "count": {
              "description": "PH({{count}}|1|There is/are {?} stop(s) during the trip.)"
            },
            "destination": {
              "description": "Destination(s) of the stop(s) (Airport code)",
              "example": "CDG, YYC"
            }
          }
        },
        "TWO": "{{count}} stops in {{destinations}}",
        "@TWO": {
          "description": "This a pluralized string of form [X stop(s) in Y]. 'Y' are all the stop destinations",
          "placeholders": {
            "count": {
              "description": "PH({{count}}|1|There is/are {?} stop(s) during the trip.)"
            },
            "destination": {
              "description": "Destination(s) of the stop(s) (Airport code)",
              "example": "CDG, YYC"
            }
          }
        },
        "FEW": "{{count}} stops in {{destinations}}",
        "@FEW": {
          "description": "This a pluralized string of form [X stop(s) in Y]. 'Y' are all the stop destinations",
          "placeholders": {
            "count": {
              "description": "PH({{count}}|5|There is/are {?} stop(s) during the trip.)"
            },
            "destination": {
              "description": "Destination(s) of the stop(s) (Airport code)",
              "example": "CDG, YYC"
            }
          }
        },
        "MANY": "{{count}} stops in {{destinations}}",
        "@MANY": {
          "description": "This a pluralized string of form [X stop(s) in Y]. 'Y' are all the stop destinations",
          "placeholders": {
            "count": {
              "description": "PH({{count}}|5|There is/are {?} stop(s) during the trip.)"
            },
            "destination": {
              "description": "Destination(s) of the stop(s) (Airport code)",
              "example": "CDG, YYC"
            }
          }
        },
        "OTHER": "{{count}} stops in {{destinations}}",
        "@OTHER": {
          "description": "This a pluralized string of form [X stop(s) in Y]. 'Y' are all the stop destinations",
          "placeholders": {
            "count": {
              "description": "PH({{count}}|5|There is/are {?} stop(s) during the trip.)"
            },
            "destination": {
              "description": "Destination(s) of the stop(s) (Airport code)",
              "example": "CDG, YYC"
            }
          }
        }
      },
      "@STOP": {
        "description": "This a pluralized string of form [X stop(s) in Y]. 'Y' are all the stop destinations",
        "placeholders": {
          "count": {
            "description": "PH({{count}}|2|There is/are {?} stop(s) during the trip.)"
          },
          "destination": {
            "description": "Destination(s) of the stop(s) (Airport code)",
            "example": "CDG, YYC"
          }
        }
      },
      "FLIGHT": "Flight",
      "OUTBOUND_FLIGHT": "Outbound flight",
      "INBOUND_FLIGHT": "Inbound flight",
      "REBOOKED_BY_AIRLINE": "Rebooked by {{partnerName}}",
      "@REBOOKED_BY_AIRLINE": {
        "description": "One of the flight of the booking has been rebooked by the airline",
        "placeholders": {
          "partnerName": {
            "description": "Name of the partner",
            "example": "Air Canada"
          }
        }
      },
      "PASSENGER_TYPE": {
        "ADULT":  {
          "ZERO": "{{count}} adults",
          "@ZERO": {
            "description": "This a pluralized string of form [X adult(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} adult(s) on this booking.)"
              }
            }
          },
          "ONE": "{{count}} adult",
          "@ONE": {
            "description": "This a pluralized string of form [X adult(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} adult(s) on this booking.)"
              }
            }
          },
          "TWO": "{{count}} adults",
          "@TWO": {
            "description": "This a pluralized string of form [X adult(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} adult(s) on this booking.)"
              }
            }
          },
          "FEW": "{{count}} adults",
          "@FEW": {
            "description": "This a pluralized string of form [X adult(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} adult(s) on this booking.)"
              }
            }
          },
          "MANY": "{{count}} adults",
          "@MANY": {
            "description": "This a pluralized string of form [X adult(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} adult(s) on this booking.)"
              }
            }
          },
          "OTHER": "{{count}} adults",
          "@OTHER": {
            "description": "This a pluralized string of form [X adult(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} adult(s) on this booking.)"
              }
            }
          }
        },
        "@ADULT": {
          "description": "This a pluralized string of form [X adult(s)].",
          "placeholders": {
            "count": {
              "description": "PH({{count}}|2|There is/are {?} adult(s) on this booking.)"
            }
          }
        },
        "CHILD": {
          "ZERO": "{{count}} children",
          "@ZERO": {
            "description": "This a pluralized string of form [X chil(ren)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} child(ren) on this booking.)"
              }
            }
          },
          "ONE": "{{count}} child",
          "@ONE": {
            "description": "This a pluralized string of form [X chil(ren)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} child(ren) on this booking.)"
              }
            }
          },
          "TWO": "{{count}} children",
          "@TWO": {
            "description": "This a pluralized string of form [X chil(ren)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} child(ren) on this booking.)"
              }
            }
          },
          "FEW": "{{count}} children",
          "@FEW": {
            "description": "This a pluralized string of form [X chil(ren)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} child(ren) on this booking.)"
              }
            }
          },
          "MANY": "{{count}} children",
          "@MANY": {
            "description": "This a pluralized string of form [X chil(ren)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} child(ren) on this booking.)"
              }
            }
          },
          "OTHER": "{{count}} children",
          "@OTHER": {
            "description": "This a pluralized string of form [X chil(ren)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} child(ren) on this booking.)"
              }
            }
          }
        },
        "@CHILD": {
          "description": "This a pluralized string of form [X chil(ren)].",
          "placeholders": {
            "count": {
              "description": "PH({{count}}|2|There is/are {?} child(ren) on this booking.)"
            }
          }
        },
        "SEATED_INFANT": {
          "ZERO": "{{count}} seated infants",
          "@ZERO": {
            "description": "This a pluralized string of form [X seated infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} seated infant(s) on this booking.)"
              }
            }
          },
          "ONE": "{{count}} seated infant",
          "@ONE": {
            "description": "This a pluralized string of form [X seated infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} seated infant(s) on this booking.)"
              }
            }
          },
          "TWO": "{{count}} seated infants",
          "@TWO": {
            "description": "This a pluralized string of form [X seated infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} seated infant(s) on this booking.)"
              }
            }
          },
          "FEW": "{{count}} seated infants",
          "@FEW": {
            "description": "This a pluralized string of form [X seated infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} seated infant(s) on this booking.)"
              }
            }
          },
          "MANY": "{{count}} seated infants",
          "@MANY": {
            "description": "This a pluralized string of form [X seated infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} seated infant(s) on this booking.)"
              }
            }
          },
          "OTHER": "{{count}} seated infants",
          "@OTHER": {
            "description": "This a pluralized string of form [X seated infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} seated infant(s) on this booking.)"
              }
            }
          }
        },
        "@SEATED_INFANT": {
          "description": "This a pluralized string of form [X seated infant(s)].",
          "placeholders": {
            "count": {
              "description": "PH({{count}}|2|There is/are {?} seated infant(s) on this booking.)"
            }
          }
        },
        "LAP_INFANT": {
          "ZERO": "{{count}} lap infants",
          "@ZERO": {
            "description": "This a pluralized string of form [X lap infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} lap infant(s) on this booking.)"
              }
            }
          },
          "ONE": "{{count}} lap infant",
          "@ONE": {
            "description": "This a pluralized string of form [X lap infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} lap infant(s) on this booking.)"
              }
            }
          },
          "TWO": "{{count}} lap infants",
          "@TWO": {
            "description": "This a pluralized string of form [X lap infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} lap infant(s) on this booking.)"
              }
            }
          },
          "FEW": "{{count}} lap infants",
          "@FEW": {
            "description": "This a pluralized string of form [X lap infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} lap infant(s) on this booking.)"
              }
            }
          },
          "MANY": "{{count}} lap infants",
          "@MANY": {
            "description": "This a pluralized string of form [X lap infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} lap infant(s) on this booking.)"
              }
            }
          },
          "OTHER": "{{count}} lap infants",
          "@OTHER": {
            "description": "This a pluralized string of form [X lap infant(s)].",
            "placeholders": {
              "count": {
                "description": "PH({{count}}|2|There is/are {?} lap infant(s) on this booking.)"
              }
            }
          }
        },
        "@LAP_INFANT": {
          "description": "This a pluralized string of form [X lap infant(s)].",
          "placeholders": {
            "count": {
              "description": "PH({{count}}|2|There is/are {?} lap infant(s) on this booking.)"
            }
          }
        }
      }
    },
    "REFUND": {
      "DEFAULT_HEADER": {
        "TITLE": "Get a refund",
        "SUBTITLE": "You will receive <b>{{amount}}</b>, 100% of your covered booking amount, as a cash refund. No change will be made to your booking with {{partnerName}}, so you will also keep your current flight itinerary.<br /><br />Let’s confirm your information so we can process your refund!",
        "@SUBTITLE": {
          "placeholders": {
            "amount": {
              "description": "100% of the covered booking amount",
              "example": "$200.00"
            },
            "partnerName": {
              "description": "Name of the partner",
              "example": "Air Canada"
            }
          }
        }
      },
      "CONFIRMATION_HEADER": {
        "TITLE": "Success! Your <b>{{amount}}</b> refund is being processed.",
        "@TITLE": {
          "description": "PH({{amount}}|$200.00|Amount of your refund)"
        },
        "SUBTITLE": "A confirmation email will be sent shortly to <b>{{email}}</b>. You still have your original flight reservation. Thank you for using {{productName}}!",
        "@SUBTITLE": {
          "placeholders": {
            "email": {
              "description": "User email",
              "example": "test@hopper.com"
            },
            "productName": {
              "description": "The name of the product",
              "example": "Flight Disruption Guarantee"
            }
          }
        }
      },
      "FORM_HEADER": {
        "PERSONAL_INFORMATION": "Personal Information",
        "HOME_ADDRESS_INFORMATION": "Home Address"
      },
      "FORM": {
        "FIRST_NAME": "First name",
        "LAST_NAME": "Last name",
        "ADDRESS_LINE_1": "Address line 1",
        "ADDRESS_LINE_2": "Address line 2 (optional)",
        "CITY": "City",
        "COUNTRY": "Country",
        "STATE": "State/Province",
        "ZIP": "Zip/Postal Code"
      }
    },
    "GENDER": {
      "MALE": "Male",
      "FEMALE": "Female",
      "UNDISCLOSED": "Undisclosed",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "HOME": {
    "CONTRACT_ALREADY_REFUNDED": "Your cancellation request has already been taken into account and your refund is in progress. If you need help, you may contact our customer support team via <a href='{{link}}' target='_blank'>this form.</a>",
    "@CONTRACT_ALREADY_REFUNDED": {
      "placeholders": {
        "link": {
          "description": "Contact form link",
          "example": "https://hopper.kustomer.help/lang/en_us/"
        }
      }
    },
    "NO_DISRUPTION": "No delayed or canceled flight found."
  },
  "NOT_FOUND": {
    "TITLE": "Page not found",
    "MESSAGE": "We are sorry. The page you are looking for cannot be found.",
    "GO_HOME": "Go Home"
  },
  "SERVICE_DISRUPTION_STEP": {
    "TITLE": "Service Temporarily Unavailable",
    "MESSAGE": "We're experiencing a service disruption, but it'll be resolved soon.",
    "TRY_AGAIN": "Please try again in a few minutes.",
    "CONTACT_CUSTOMER_SUPPORT": "Contact Customer Support"
  },
  "FLIGHT_INFORMATIONS": {
    "NOT_ELIGIBLE": "We're monitoring your flight. Come back here if you experience a delay of more than {{minMinutesDelay}} minutes or cancellation within {{maxHoursBeforeDeparture}} hours of departure.",
    "@NOT_ELIGIBLE": {
      "placeholders": {
        "minMinutesDelay": {
          "description": "Minimum time for a disruption to be valid, in minutes.",
          "example": "20"
        },
        "maxHoursBeforeDeparture": {
          "description": "Maximum time to handle the disruption, in hours.",
          "example": "24"
        }
      }
    },
    "CHOICE_SELECTION": "What would you like to do?",
    "REBOOK": {
      "TITLE": "Rebook a new flight",
      "DESC": "You can choose to rebook a new flight on any airline, selecting between flights departing today or tomorrow."
    },
    "REFUND": {
      "TITLE": "Get a refund and keep your itinerary",
      "DESC": "If you’re not satisfied with your rebooking options, get a refund of <b>{{amount}}</b> and keep your disrupted flight."
    }
  },
  "PRODUCT_INFORMATIONS": {
    "PRODUCT_INFO": "Because you purchased {{productName}}, you are entitled to a rebooking or, if you are not satisfied with our rebooking options, a refund, if your flight has been cancelled or delayed for more than {{minMinutesDelay}} minutes, within {{maxHoursBeforeDeparture}} hours of departure.",
    "@PRODUCT_INFO": {
      "placeholders": {
        "productName": {
          "description": "Product name",
          "example": "Flight Disruption Guarantee"
        },
        "minMinutesDelay": {
          "description": "Minimum time for a disruption to be valid, in minutes.",
          "example": "20"
        },
        "maxHoursBeforeDeparture": {
          "description": "Maximum time to handle the disruption, in hours.",
          "example": "24"
        }
      }
    },
    "PRODUCT_INFO_HOURS": "Because you purchased {{productName}}, you are entitled to a rebooking or, if you are not satisfied with our rebooking options, a refund, if your flight has been cancelled or delayed for more than {{minMinutesDelay}} hours, within {{maxHoursBeforeDeparture}} hours of departure.",
    "@PRODUCT_INFO_HOURS": {
      "placeholders": {
        "productName": {
          "description": "Product name",
          "example": "Flight Disruption Guarantee"
        },
        "minMinutesDelay": {
          "description": "Minimum time for a disruption to be valid, in minutes.",
          "example": "20"
        },
        "maxHoursBeforeDeparture": {
          "description": "Maximum time to handle the disruption, in hours.",
          "example": "24"
        }
      }
    }

  },
  "SLICE_DETAILS_DIALOG": {
    "TITLE": "Outbound flight to {{destination}}",
    "@TITLE": {
      "description": "PH({{destination}}|Vancouver|Destination of the flight)"
    }
  },
  "SLICE_INFORMATIONS": {
    "ELIGIBLE_FOR_REBOOKING": "Eligible for Rebooking",
    "NOT_ELIGIBLE_FOR_REBOOKING": "Not eligible for Rebooking"
  },
  "SEND_VERIFICATION_CODE_STEP": {
    "SEND_VERIFICATION_TITLE": "Let’s make sure it’s really you!",
    "SEND_VERIFICATION_TEXT": "We’ll send a code to the email you used when you booked your flight.",
    "BUTTON": {
      "SEND_VERIFICATION_CODE": "Send code",
      "@SEND_VERIFICATION_CODE": {
        "description": "Sends the verification code to verify the user's identity."
      }
    }
  },
  "CHECK_VERIFICATION_CODE_STEP": {
    "CHECK_VERIFICATION_TITLE": "Let’s make sure it’s really you!",
    "CHECK_VERIFICATION_TEXT": "We just sent an email with a verification code to {{email}}.",
    "@CHECK_VERIFICATION_TEXT": {
      "description": "PH({{email}}|test@hopper.com|user email)"
    },
    "BUTTON": {
      "RESEND_VERIFICATION_CODE": "Send a new code"
    }
  },
  "HYPERWALLET_FORM_STEP": {
    "FORM": {
      "MIDDLE_NAME": "Middle name (optional)",
      "DATE_OF_BIRTH": "Date of birth"
    }
  },
  "HYPERWALLET_REFUND_STEP": {
    "RECEIVE_AMOUNT_TITLE": "How would you like to receive your refund?"
  },
  "SPREEDLY_FORM_STEP": {
    "CARD_INFORMATION": "Card Information",
    "FORM": {
      "FULL_NAME": "Full name",
      "CARD_NUMBER": "Card number",
      "EXPIRATION_MONTH": "Expiration month",
      "EXPIRATION_YEAR": "Expiration year",
      "CVV": "CVV",
      "@CVV": {
        "description": "Card verification value: unique code printed on payment cards that's used to authorize payments made online"
      }
    },
    "BUTTON": {
      "REDIRECT_TO_BANK_TRANSFER": "I don't have a credit card"
    }
  },
  "BANK_TRANSFER_FORM_STEP": {
    "DESC": "We will send your refund to your bank account.",
    "FORM": {
      "BANK_INFORMATION": "Bank Account Information",
      "ACCOUNT_NUMBER": "IBAN/Bank Account Number",
      "@ACCOUNT_NUMBER": {
        "description": "IBAN stands for International Bank Account Number, which you can use when making or receiving international payments."
      },
      "BANK_ID": "SWIFT/BIC code",
      "@BANK_ID": {
        "description": "BIC stands for Bank Identifier Code. It is an 8 to 11-character code that identifies banks globally. BIC codes are used to send money between banks to ensure money is directed to the right place."
      },
      "ACCOUNT_HOLDER_INFORMATION": "Account Holder Information",
      "VALIDATION": {
        "REQUIRED": "This field is required",
        "INVALID_IBAN": "Please enter a valid IBAN",
        "INVALID_BIC": "Please enter a valid SWIFT/BIC code",
        "formValidationAccountNumberRequired": "Please enter your bank account number.",
        "formValidationBankCodeRequired": "Please enter your bank code.",
        "formValidationBankCodeLength": "Bank code must be between 8 and 11 characters.",
        "formValidationBankCodeFirstChars": "Bank code must start with 4 letters.",
        "formValidationBankCodeCountryUnsupported": "This bank code's country is not supported for international transfers.",
        "formValidationBankCodeCountryInvalid": "The country code in your bank code is invalid.",
        "formValidationBankCodeLocationInvalid": "The location code in your bank code is invalid.",
        "formValidationBankCodeBranchInvalid": "The branch code in your bank code is invalid.",
        "formValidationIbanCharsInvalid": "Your bank account number contains invalid characters. Please use only letters and numbers.",
        "formValidationIbanCountryInvalid": "Your bank account number must start with a valid country code.",
        "formValidationIbanCountryUnsupported": "This bank account number's country is not supported for international transfers.",
        "formValidationIbanLengthInvalid": "Your bank account number has an invalid length for this country.",
        "formValidationIbanChecksumInvalid": "Your bank account number is invalid. Please check and try again.",
        "formValidationIbanBicCountryMismatch": "The country in your bank account number does not match the country in your bank code."
      }
    }
  },
  "PAYOUT_ERROR_STEP": {
    "TITLE": "We couldn't process your {{productName}} request",
    "@TITLE": {
      "placeholders": {
        "productName": {
          "description": "The name of the product",
          "example": "Flight Disruption Guarantee"
        }
      }
    },
    "SUBTITLE": "We apologize for the inconvenience, but we faced a problem while issuing your refund. Please click <b>Continue</b> to review our options for processing your refund. If you have any difficulty please reach out to our customer support via <a href='{{link}}' target='_blank'>this form.</a>",
    "@SUBTITLE": {
      "placeholders": {
        "link": {
          "description": "Contact form link",
          "example": "https://hopper.kustomer.help/lang/en_us/"
        }
      }
    },
    "NO_PAYOUT_OPTIONS": "Please contact our customer support via <a href='{{link}}' target='_blank'>this form.</a>",
    "@NO_PAYOUT_OPTIONS": {
      "placeholders": {
        "link": {
          "description": "Contact form link",
          "example": "https://hopper.kustomer.help/lang/en_us/"
        }
      }
    }
  },
  "REBOOKING_CONFIRMATION_STEP": {
    "TITLE": "Sit back and relax! Your new booking is confirmed.",
    "SUBTITLE": "A confirmation email will be sent shortly to {{email}}. Thank you for using {{productName}}!",
    "@SUBTITLE": {
      "placeholders": {
        "email": {
          "description": "User email",
          "example": "test@hopper.com"
        },
        "productName": {
          "description": "The name of the product",
          "example": "Flight Disruption Guarantee"
        }
      }
    },
    "YOUR_NEW_FLIGHT": "Your new flight",
    "ROUND_TRIP_WARNING": "We strongly advise confirming directly with Frontier Airlines that any remaining flights in your booking, including any return flights, will not be canceled if you decline or skip Frontier Airlines offered rebooking options."
  },
  "REBOOKING_FORM_STEP": {
    "TITLE": "Passenger information",
    "SUBTITLE": "Let’s confirm your information before rebooking your flight.",
    "LOADING_REBOOK": "Rebooking in progress...",
    "PASSENGER": "Passenger {{index}}",
    "@PASSENGER": {
      "description": "PH({{index}}|1|Index of the passenger in a passenger list."
    },
    "BUTTON": {
      "SUBMIT": "Confirm and rebook"
    },
    "TRAVEL_DOCUMENT": "Travel Document",
    "FORM": {
      "FIRST_NAME": "First name",
      "LAST_NAME": "Last name",
      "GENDER": "Gender",
      "DOCUMENT_TYPE": "Document type",
      "PASSPORT_NUMBER": "Passport number",
      "COUNTRY_ISSUANCE": "Country of issuance",
      "NATIONALITY": "Nationality",
      "ISSUANCE_DATE": "Issuance date",
      "EXPIRATION_DATE": "Expiration date",
      "DATE_OF_BIRTH": "Date of birth",
      "NATIONAL_ID_NUMBER": "National ID number"
    },
    "DOCUMENT_TYPES": {
      "passport": "Passport",
      "national_id": "National ID"
    }
  },
  "REBOOKING_REVIEW_STEP": {
    "TITLE": "Rebook your flight",
    "SUBTITLE": "You can choose to rebook a new flight free of charge (up to {{serviceCap}} per passenger), choosing from same or next day flights. If you choose a new flight, your initial {{partnerName}} flight will be canceled but you will keep your return flights, if applicable.",
    "@SUBTITLE": {
      "placeholders": {
        "serviceCap": {
          "description": "Amount of the service cap.",
          "example": "$300"
        },
        "partnerName": {
          "description": "Name of the partner",
          "example": "Air Canada"
        }
      }
    },
    "LOADING_REBOOK": "Rebooking in progress...",
    "CHOICE_SUMMARY": "Here is a summary of your selection",
    "DIFFERENT_AIRPORT": "Please check your itinerary as you have selected a flight itinerary departing from or arriving to a different airport compared to your initial flight."
  },
  "REBOOKING_SEARCH_ALTERNATIVES_STEP": {
    "TITLE": "Rebook your flight",
    "SUBTITLE": "You can choose to rebook a new flight free of charge (up to {{serviceCap}} per passenger), choosing from same or next day flights. If you choose a new flight, your initial {{partnerName}} flight will be canceled but you will keep your return flights, if applicable.",
    "@SUBTITLE": {
      "placeholders": {
        "serviceCap": {
          "description": "Amount of the service cap.",
          "example": "$300"
        },
        "partnerName": {
          "description": "Name of the partner",
          "example": "Air Canada"
        }
      }
    },
    "LOADING_REBOOK": "Rebooking in progress...",
    "LOADING_ALTERNATIVES": "Please wait while we are loading your rebooking options",
    "ONE_MORE_ALTERNATIVE": "{{nbAlternative}} more alternative",
    "@ONE_MORE_ALTERNATIVE": {
      "description": "PH({{nbAlternative}}|1|There is one more alternative available)"
    },
    "MORE_ALTERNATIVES": "{{nbAlternative}} more alternatives",
    "@MORE_ALTERNATIVES": {
      "description": "PH({{nbAlternative}}|2|There is more than one alternative available)"
    },
    "NO_ALTERNATIVE": "We are sorry, there are no available flight options for this day of departure at the moment. You may choose between one of the following options: ",
    "BAGS_TITLE": "Do you have bags checked in?",
    "BUTTON": {
      "YES": "Yes",
      "@YES": {
        "description": "The user has already checked baggage on their disrupted flight."
      },
      "NO": "No",
      "@NO": {
        "description": "The user has not yet checked their baggage on their disrupted flight, or they simply do not have any baggage."
      },
      "GO_TO_REFUND_FLOW": "Choose our refund option",
      "SEARCH_FOR_OTHER_DAY": "Look for flights one day before or after"
    },
    "OUTBOUND": "Outbound to {{destination}}",
    "@OUTBOUND": {
      "description": "PH({{destination}}|New york|Destination of the flight)"
    },
    "NO_STOP": "Direct",
    "STOP": {
      "ZERO": "{{count}} stops",
      "@ZERO": {
        "description": "This a pluralized string of form [X stop(s)]",
        "placeholders": {
          "count": {
            "description": "PH({{count}}|1|There is/are {?} stop(s) during the trip.)"
          }
        }
      },
      "ONE": "{{count}} stop",
      "@ONE": {
        "description": "This a pluralized string of form [X stop(s)]",
        "placeholders": {
          "count": {
            "description": "PH({{count}}|1|There is/are {?} stop(s) during the trip.)"
          }
        }
      },
      "TWO": "{{count}} stops",
      "@TWO": {
        "description": "This a pluralized string of form [X stop(s)]",
        "placeholders": {
          "count": {
            "description": "PH({{count}}|1|There is/are {?} stop(s) during the trip.)"
          }
        }
      },
      "FEW": "{{count}} stops",
      "@FEW": {
        "description": "This a pluralized string of form [X stop(s)]",
        "placeholders": {
          "count": {
            "description": "PH({{count}}|5|There is/are {?} stop(s) during the trip.)"
          }
        }
      },
      "MANY": "{{count}} stops",
      "@MANY": {
        "description": "This a pluralized string of form [X stop(s)]",
        "placeholders": {
          "count": {
            "description": "PH({{count}}|5|There is/are {?} stop(s) during the trip.)"
          }
        }
      },
      "OTHER": "{{count}} stops",
      "@OTHER": {
        "description": "This a pluralized string of form [X stop(s)]",
        "placeholders": {
          "count": {
            "description": "PH({{count}}|5|There is/are {?} stop(s) during the trip.)"
          }
        }
      }
    },
    "@STOP": {
      "description": "This a pluralized string of form [X stop(s)]",
      "placeholders": {
        "count": {
          "description": "PH({{count}}|2|There is/are {?} stop(s) during the trip.)"
        }
      }
    },
    "SEE_OTHER_AIRLINES": "Show additional airlines"
  },
  "WARNING_BAGS_DIALOG": {
    "TITLE": "Important notice on checked bags",
    "DESC": "Since you already have checked-in bags on your disrupted flight with the airline, they must be offloaded and checked in again on your new flight. To do so, please visit the airline’s check-in counter at the airport.<br /><br />We cannot guarantee that your bags will be offloaded in time to check them for your new flight.",
    "DESC_FLYADEAL": "Since you already have checked-in bags on your disrupted flight with the airline, they must be offloaded and checked-in again on your new flight. To do so, please visit the airline customer service or baggage claim service at the airport to get your baggage.<br /><br />Collecting and checking your bags in the new flight in time is your responsibility.",
    "BUTTON": {
      "REFUND": "Keep flight and get a refund",
      "REBOOK": "Rebook and manage my own bags"
    }
  },
  "ALTERNATIVE_DETAILS_DIALOG": {
    "TITLE": "Outbound flight to {{destination}}",
    "@TITLE": {
      "description": "PH({{destination}}|Vancouver|Destination of the alternative flight)"
    },
    "BUTTON": {
      "SUBMIT": "Select this flight"
    }
  }
}
